import {NgModule} from "@angular/core";
import {PbDatePipe} from "./pb-date-pipe";

@NgModule({
  declarations: [PbDatePipe],
  exports: [PbDatePipe],
})
export class PbDatePipeModule {
}
